module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/website-7e3266a2effe797d000bd1f2b50acac9.png";